export default {
    purchaseOrderDetail: null,
    tabStatus: null
}


// WEBPACK FOOTER //
// ./src/store/purchase-order/state.js